import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const StatusPopover = ({ isOpen, onClose, onSelect, position, selectedStatus, selectedTab }) => {
  const { t } = useTranslation();
  const [hoveredIndex, setHoveredIndex] = useState(-1);
  const popoverRef = useRef(null);

  // All available statuses
  const allStatuses = [
    { id: 'Initiated', name: t('transactions.statusInitiated'), color: 'green' },
    { id: 'Confirmed', name: t('transactions.statusConfirmed'), color: 'yellow' },
    { id: 'Failed', name: t('transactions.statusFailed'), color: 'gray' },
    { id: 'Pending', name: t('transactions.statusPending'), color: 'gray' },
    { id: 'Api_failed', name: t('transactions.statusApiFailed'), color: 'gray' },
    { id: 'Expired', name: t('transactions.statusExpired'), color: 'gray' },
  ];

  // Filter statuses based on selected tab
  // For Deposits, Payouts, and Withdrawals tabs, only show Confirmed, Failed, Pending
  const getFilteredStatuses = () => {
    if (selectedTab === 'Deposit' || selectedTab === 'Payout' || selectedTab === 'Withdrawal') {
      return allStatuses.filter(status => 
        status.id === 'Confirmed' || 
        status.id === 'Failed' || 
        status.id === 'Pending'
      );
    }
    // For 'All' tab or any other tab, show all statuses
    return allStatuses;
  };

  const statuses = getFilteredStatuses();

  // Close popover when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleStatusSelect = (status) => {
    onSelect(status);
    onClose();
  };

  const getStatusColor = (color) => {
    switch (color) {
      case 'green':
        return 'bg-green-100 text-green-800';
      case 'yellow':
        return 'bg-yellow-100 text-yellow-800';
      case 'red':
        return 'bg-red-100 text-red-800';
      case 'gray':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (!isOpen) return null;

  return (
    <div
      ref={popoverRef}
      className="fixed z-50 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[200px]"
      style={{
        top: position?.top || 0,
        left: position?.left || 0,
      }}
    >
      {statuses.map((status, index) => (
        <div
          key={status.id}
          className={`px-4 py-3 cursor-pointer transition-colors ${
            selectedStatus?.id === status.id
              ? 'bg-gray-100 text-gray-900'
              : hoveredIndex === index
              ? 'bg-gray-50 text-gray-900'
              : 'text-gray-700 hover:bg-gray-50'
          }`}
          style={{ borderRadius: "10px", margin: "4px" }}
          onMouseEnter={() => setHoveredIndex(index)}
          onMouseLeave={() => setHoveredIndex(-1)}
          onClick={() => handleStatusSelect(status)}
        >
          <div className="flex items-center gap-3">
            {/* <div className={`w-2 h-2 rounded-full ${getStatusColor(status.color).split(' ')[0]}`}></div> */}
            <span className="text-sm font-medium">{status.name}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatusPopover;